import React, { useEffect, useState } from 'react';
import { Challenge, CustomerChallenge as CustomerChallengeEntry } from '../../types/customer';
import ListViewWithModal from '../Common/ListViewWithModal';
import { useChallenges } from '../../hooks/useToolboxHooks';
import { useAddCustomerChallengeMutation, useDeleteCustomerChallengeMutation, useFetchCustomerChallenges } from '../../hooks/customer-hooks';


interface CustomerChallengeProps {
  customerID: string | number;
}

const CustomerChallenge: React.FC<CustomerChallengeProps> = ({ customerID }) => {
  const { challenges, lookup, loading, error } = useChallenges();
  const { data: customerChallengeEntries } = useFetchCustomerChallenges({customer: customerID as string }, { enabled: !!customerID });
  const [customerChallenges, setCustomerChallenges] = useState<(Challenge & { customerEntry?: number })[]>([]);
  const { mutate: addCustomerChallenge } = useAddCustomerChallengeMutation();
  const { mutate: deleteCustomerChallenge } = useDeleteCustomerChallengeMutation();

  useEffect(() => {
    if (!customerChallengeEntries?.length || !challenges?.length) {
      setCustomerChallenges([]);
      return;
    }

    for (const entry of customerChallengeEntries) {
      const filteredChallenges = customerChallengeEntries.map((c: CustomerChallengeEntry) => ({ ...lookup[c.challenge] as Challenge, customerEntry: c.id }))
      setCustomerChallenges(filteredChallenges);
    }
  }, [challenges, customerChallengeEntries, lookup]);

  if (loading) return <div>Loading challenges...</div>;
  if (error) return <div>Error loading challenges: {error}</div>;

  return (
    <ListViewWithModal<Challenge & { customerEntry?: number }>
      title="Challenges"
      items={customerChallenges}
      availableItems={challenges}
      onAddItem={(item) => addCustomerChallenge({ customer: customerID as string, challenge: item.id })}
      onDeleteItem={(id) => deleteCustomerChallenge({ customer: customerID as string, id: customerChallenges.find(c => c.id.toString() === id)?.customerEntry })}
      idKey="id"
      nameKey="name"
      descriptionKey="description"
    />
  );
};

export default CustomerChallenge;